import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token: string | null = localStorage ? localStorage.getItem('token') : null;
    const isLoginRequest = request.url.includes('/authentication/login');
    const isReloginRequest = request.url.includes('/authentication/relogin');
    // Публічні ендпоінти входу за QR-кодом: протермінований токен з localStorage не має спричиняти 401 і релогін
    const isQrLoginRequest = request.url.includes('/organization/v1/qr/');

    if (!isLoginRequest && !isReloginRequest && !isQrLoginRequest && token !== null) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(request);
  }
}

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((response: any) => {
        return throwError(response);
      })
    );
  }
}
